const SET_ACTIVE_DRAW_TOOL = 'SET_ACTIVE_DRAW_TOOL';
const SET_FILTER_GEOMETRY = 'SET_FILTER_GEOMETRY';
const SET_IN_IMSR = 'SET_IN_IMSR';
const SET_USE_EXTENT_FILTER = 'SET_USE_EXTENT_FILTER';
const SET_FILTER_LOADING = 'SET_FILTER_LOADING';
const SET_FILTER_VISIBLE = 'SET_FILTER_VISIBLE';
const ADD_FIRE_CAUSE = 'ADD_FIRE_CAUSE';
const REMOVE_FIRE_CAUSE = 'REMOVE_FIRE_CAUSE';
const CLEAR_FIRE_CAUSE = 'CLEAR_FIRE_CAUSE';
const ADD_INITIAL_STRATEGY = 'ADD_INITIAL_STRATEGY';
const REMOVE_INITIAL_STRATEGY = 'REMOVE_INITIAL_STRATEGY';
const CLEAR_DATA_SOURCE = 'CLEAR_DATA_SOURCE';
const REMOVE_DATA_SOURCE = 'REMOVE_DATA_SOURCE';
const SET_MULTI_ROOT = 'SET_MULTI_ROOT';
const SET_MAP_DRAWING_PAUSED = 'SET_MAP_DRAWING_PAUSED';
const ADD_DATA_SOURCE = 'ADD_DATA_SOURCE';
const SET_NARRATIVE_FILTER = 'SET_NARRATIVE_FILTER';
const CLEAR_INITIAL_STRATEGY = 'CLEAR_INITIAL_STRATEGY';
const ADD_LANDOWNER_CATEGORY = 'ADD_LANDOWNER_CATEGORY';
const RESET_FILTERS = 'RESET_FILTERS';
const REMOVE_LANDOWNER_CATEGORY = 'REMOVE_LANDOWNER_CATEGORY';
const CLEAR_LANDOWNER_CATEGORY = 'CLEAR_LANDOWNER_CATEGORY';
const ADD_INITIAL_TYPE = 'ADD_INITIAL_TYPE';
const REMOVE_INITIAL_TYPE = 'REMOVE_INITIAL_TYPE';
const CLEAR_INITIAL_TYPE = 'CLEAR_INITIAL_TYPE';
const SET_FIRE_ACRE_FILTER = 'SET_FIRE_ACRE_FILTER';
const CLEAR_FIRE_ACRE_FILTER = 'CLEAR_FIRE_ACRE_FILTER';
const SET_FIRE_DISCOVERY_DATES = 'SET_FIRE_DISCOVERY_DATES';
const CLEAR_FIRE_DISCOVERY_DATES = 'CLEAR_FIRE_DISCOVERY_DATES';
const SET_FIRE_OUT_DATES = 'SET_FIRE_OUT_DATES';
const CLEAR_FIRE_OUT_DATES = 'CLEAR_FIRE_OUT_DATES';
const SET_MODIFIED_DATES = 'SET_MODIFIED_DATES';
const SET_BASIC_FILTER_ACTIVE  = 'SET_BASIC_FILTER_ACTIVE';
const REMOVE_IRWIN_RELATIONSHIP = 'REMOVE_IRWIN_RELATIONSHIP';
const CLEAR_IRWIN_RELATIONSHIPS = 'CLEAR_IRWIN_RELATIONSHIPS';
const ADD_IRWIN_RELATIONSHIP = 'ADD_IRWIN_RELATIONSHIP';
const CLEAR_MODIFIED_DATES = 'CLEAR_MODIFIED_DATES';
const SET_STRUCTURES_FILTER = 'SET_STRUCTURES_FILTER';
const SET_INJURIES_FILTER = 'SET_INJURIES_FILTER';
const SET_UNIQUENESS_FILTER = 'SET_UNIQUENESS_FILTER';
const SET_FATALITIES_FILTER = 'SET_FATALITIES_FILTER';
const SET_PERIMETER_MAP_METHOD_FILTER = 'SET_PERIMETER_MAP_METHOD_FILTER';
const	SET_PERIMETER_FEATURE_STATUS_FILTER = 'SET_PERIMETER_FEATURE_STATUS_FILTER';
const	SET_PERIMETER_FEATURE_ACCESS_FILTER = 'SET_PERIMETER_FEATURE_ACCESS_FILTER';
const SET_OTHER_STRUCTURES_DESTROYED_FILTER = 'SET_OTHER_STRUCTURES_DESTROYED_FILTER';
const SET_RESIDENCES_THREATENED_FILTER = 'SET_RESIDENCES_THREATENED_FILTER';
const SET_OTHER_STRUCTURES_THREATENED_FILTER = 'SET_OTHER_STRUCTURES_THREATENED_FILTER';
const SET_CERTIFIED_FILTER = 'SET_CERTIFIED_FILTER';
const SET_CAPABILITY_REQUESTS_FILTER = 'SET_CAPABILITY_REQUESTS_FILTER';
const SET_GACC_FILTER = 'SET_GACC_FILTER';
const SET_RESPONSE_AGENCIES_FILTER = 'SET_RESPONSE_AGENCIES_FILTER';
const SET_STATE_FILTER = 'SET_STATE_FILTER';
const SET_COUNTY_FILTER = 'SET_COUNTY_FILTER';
const SET_REPORT_SEARCH_TERMS = 'SET_REPORT_SEARCH_TERMS';
const SET_INCIDENT_JURISDICTIONAL_AGENCY = 'SET_INCIDENT_JURISDICTIONAL_AGENCY';
const SET_DISPATCH_CENTER_ID = 'SET_DISPATCH_CENTER_ID';
const SET_POO_PROTECTING_UNIT = 'SET_POO_PROTECTING_UNIT';
const SET_POO_PROTECTING_AGENCY = 'SET_POO_PROTECTING_AGENCY';
const SET_JURISDICTIONAL_UNIT = 'SET_JURISDICTIONAL_UNIT';
const ADD_UNIQUE_FIRE_ID = 'ADD_UNIQUE_FIRE_ID';
const REMOVE_UNIQUE_FIRE_ID = 'REMOVE_UNIQUE_FIRE_ID';
const CLEAR_UNIQUE_FIRE_ID = 'CLEAR_UNIQUE_FIRE_ID';
const SET_MODIFIED_BY_SYSTEM_FILTER = 'SET_MODIFIED_BY_SYSTEM_FILTER';
const SET_CREATED_BY_SYSTEM_FILTER = 'SET_CREATED_BY_SYSTEM_FILTER';
const SET_UTC_OFFSET_FILTER = 'SET_UTC_OFFSET_FILTER';
const CLEAR_UTC_OFFSET_FILTER = 'CLEAR_UTC_OFFSET_FILTER';
const MANUAL_REHYDRATE_FILTER = 'MANUAL_REHYDRATE_FILTER';
const CLEAR_PERIMETER_ACREAGE = 'CLEAR_PERIMETER_ACREAGE';
const SET_PERIMETER_ACREAGE_LANDOWNER = 'SET_PERIMETER_ACREAGE_LANDOWNER';
const SET_PERIMETER_ACREAGE_OPERATOR = 'SET_PERIMETER_ACREAGE_OPERATOR';
const SET_PERIMETER_ACREAGE_NUMBER = 'SET_PERIMETER_ACREAGE_NUMBER';
const SET_PERIMETER_ACREAGE_IDS = 'SET_PERIMETER_ACREAGE_IDS';
const SET_HAS_SPATIAL_FILTER = 'SET_HAS_SPATIAL_FILTER';
const SET_SPATIAL_FILTER_ID = 'SET_SPATIAL_FILTER_ID';
const SET_IMSR_DATES = 'SET_IMSR_DATES';
const CLEAR_IMSR_DATES = 'CLEAR_IMSR_DATES';
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  MANUAL_REHYDRATE_FILTER,
  SET_ACTIVE_DRAW_TOOL,
  SET_FILTER_GEOMETRY,
  SET_USE_EXTENT_FILTER,
  SET_FILTER_LOADING,
  SET_FILTER_VISIBLE,
  ADD_FIRE_CAUSE,
  REMOVE_FIRE_CAUSE,
  SET_MAP_DRAWING_PAUSED,
  CLEAR_FIRE_CAUSE,
  ADD_INITIAL_STRATEGY,
  REMOVE_INITIAL_STRATEGY,
  CLEAR_INITIAL_STRATEGY,
  ADD_LANDOWNER_CATEGORY,
  REMOVE_LANDOWNER_CATEGORY,
  CLEAR_LANDOWNER_CATEGORY,
  REMOVE_IRWIN_RELATIONSHIP,
  CLEAR_IRWIN_RELATIONSHIPS,
  ADD_IRWIN_RELATIONSHIP,
  ADD_INITIAL_TYPE,
  REMOVE_INITIAL_TYPE,
  CLEAR_INITIAL_TYPE,
  SET_FIRE_ACRE_FILTER,
  CLEAR_FIRE_ACRE_FILTER,
  SET_FIRE_DISCOVERY_DATES,
  CLEAR_FIRE_DISCOVERY_DATES,
  SET_FIRE_OUT_DATES,
  CLEAR_FIRE_OUT_DATES,
  SET_MODIFIED_DATES,
  CLEAR_IMSR_DATES,
  SET_IMSR_DATES,
  SET_IN_IMSR,
  CLEAR_MODIFIED_DATES,
  SET_STRUCTURES_FILTER,
  SET_INJURIES_FILTER,
  SET_UNIQUENESS_FILTER,
  SET_FATALITIES_FILTER,
  SET_BASIC_FILTER_ACTIVE,
  SET_PERIMETER_MAP_METHOD_FILTER,
	SET_PERIMETER_FEATURE_STATUS_FILTER,
	SET_PERIMETER_FEATURE_ACCESS_FILTER,
  SET_OTHER_STRUCTURES_DESTROYED_FILTER,
  SET_RESIDENCES_THREATENED_FILTER,
  SET_OTHER_STRUCTURES_THREATENED_FILTER,
  SET_CERTIFIED_FILTER,
  SET_GACC_FILTER,
  SET_RESPONSE_AGENCIES_FILTER,
  SET_STATE_FILTER,
  SET_COUNTY_FILTER,
  SET_POO_PROTECTING_UNIT,
  SET_POO_PROTECTING_AGENCY,
  SET_REPORT_SEARCH_TERMS,
  SET_INCIDENT_JURISDICTIONAL_AGENCY,
  SET_DISPATCH_CENTER_ID,
  SET_JURISDICTIONAL_UNIT,
  RESET_FILTERS,
  SET_NARRATIVE_FILTER,
  ADD_UNIQUE_FIRE_ID,
  SET_CAPABILITY_REQUESTS_FILTER,
  REMOVE_UNIQUE_FIRE_ID,
  CLEAR_UNIQUE_FIRE_ID,
  SET_MODIFIED_BY_SYSTEM_FILTER,
  SET_CREATED_BY_SYSTEM_FILTER,
  ADD_DATA_SOURCE,
  REMOVE_DATA_SOURCE,
  CLEAR_DATA_SOURCE,
  SET_MULTI_ROOT,
  SET_UTC_OFFSET_FILTER,
  CLEAR_UTC_OFFSET_FILTER,
  SET_PERIMETER_ACREAGE_LANDOWNER,
  SET_PERIMETER_ACREAGE_OPERATOR,
  SET_PERIMETER_ACREAGE_NUMBER,
  CLEAR_PERIMETER_ACREAGE,
  SET_PERIMETER_ACREAGE_IDS,
  SET_HAS_SPATIAL_FILTER,
  SET_SPATIAL_FILTER_ID
};
